<script setup>
import { useI18n } from 'vue-i18n'
const { t } = useI18n()
</script>

<template>
  <section
    class="hero-equal-height pt-165 pb-100 text-white"
    style="background: url('/assets/bg-illustration.svg') no-repeat center center / cover;"
  >
    <div
      class="hero-bottom-shape-two"
      style="background: url('/assets/hero-bottom-shape.svg') no-repeat bottom center"
    ></div>

    <div class="container">
      <div class="row align-items-center">
        <!-- Левая колонка: Текст -->
        <div class="col-12 col-lg-6 d-flex flex-column justify-content-center">
          <div class="hero-slider-content  p-3" style="max-width: 600px; min-height: 300px;">
            <h1 class="hero-title fw-bold mb-3">
              {{ t('hero.title_1') }}
            </h1>
            <h2 class="hero-title fw-semibold mb-3">
              {{ t('hero.title_2') }}
            </h2>

            <p class="lead hero-lead mb-2">
              {{ t('hero.lead_1') }}
            </p>
            <p class="lead hero-lead mb-2">
              {{ t('hero.lead_2') }}
            </p>
            <p class="lead hero-lead mb-4">
              {{ t('hero.lead_3') }}
            </p>

            
            <div class="action-btns">
              <a href="/accounts/sign_in" class="btn accent-solid-btn" style="min-width: 110px; text-align: center;">
               {{ t('hero.login_btn') }}
              </a>
            </div>
          </div>
        </div>

        <!-- Правая колонка: Изображения -->
        <div class="col-12 col-lg-6 text-center mt-4 mt-lg-0">
          <div class="hero-animation-img position-relative">
            <img
              src="/assets/hero-animation-01.svg"
              alt="Hero animation"
              class="img-fluid d-none d-lg-block animation-two position-absolute"
              style="top: 0; left: 50%; transform: translateX(-50%); width: 180px;"
            />
            <img
              src="/assets/hero-single-img-5.svg"
              alt="Hero main"
              class="animation-one img-fluid"
              style="max-width: 100%; height: auto;"
            />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>


<style>
.hero-title {
  color: #fff;
}

</style>